var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('ShareBar'),_c('keep-alive',{attrs:{"include":"mallList"}},[_c('router-view')],1),_c('div',{ref:"footer",staticClass:"section section6",attrs:{"id":"page1"}},[_c('Footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }